/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class HealthService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get health
     * @returns any OK.
     * @throws ApiError
     */
    check(options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/health', errors: {
                400: `Bad Request.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get self health
     * @returns any OK.
     * @throws ApiError
     */
    checkSelf(options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/health/self', errors: {
                400: `Bad Request.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=HealthService.js.map